import { render, staticRenderFns } from "./PublicWelfareClassDetail.vue?vue&type=template&id=d78c3f7c&scoped=true"
import script from "./PublicWelfareClassDetail.vue?vue&type=script&lang=js"
export * from "./PublicWelfareClassDetail.vue?vue&type=script&lang=js"
import style0 from "./PublicWelfareClassDetail.vue?vue&type=style&index=0&id=d78c3f7c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d78c3f7c",
  null
  
)

export default component.exports